import { styled, css } from 'utils/styles';

export const Field = styled.div(
	({ theme: { space } }) => css`
		margin-bottom: ${space.large};
	`
);
